
export const formatPartnerData = (allData: any[] = []) => {
  return allData.map(item => ({
    ...item,
    address: [
      item.address,
      item.city,
      item.region,
      item.zip,
    ]
      .filter(Boolean)
      .join(', ')
  }));
};
